import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Popover, Radio,Divider} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {modeIcon} from "./config-resourceIcon"

import calendar from '../view/Resource/img/calendar _1.png'
import selectCalendar from '../view/Resource/img/calendar .png'
import MyIconSvg from "./svg/Svg";


export default class Patter  extends BaseComponent {
    static defaultProps = {
        type: 'small',//小图标  大图标  中图标
        status: '4',//默认名称 升序
        selectCard: true,//卡片模式
        selectList: false,//list 模式
        selectTimeAxis: false,//时光轴模式
        selectType: false,//大 中 小  名称  时间  日期模式的按钮
        sortField: 'createTime',//排序字段
        order: "-1",//正序|倒序  1|-1
    };
    static propTypes = {
        type: PropTypes.string,
        status: PropTypes.string,
        selectCard: PropTypes.bool,
        selectList:  PropTypes.bool,
        selectTimeAxis:  PropTypes.bool,
        selectType:  PropTypes.bool,
        sortField:  PropTypes.string,
        order:  PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            type: 'small',//小图标  大图标  中图标
            status: '5',//默认名称 升序
            currentSort: {
                sortCondition: 'type',//排序字段
                sortType: '1'//正序|倒序  1|-1
            },
            currentChecked: {},
            pictureCollection: [],
            modeIcon: [{
                type: "card",
                checked:true,
            },
                {
                    type: "list",
                    checked:false,
                },
                {
                    type: "timeAxis",
                    checked:false,
                }]
        }

    }
    componentWillMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
    }
    componentDidMount() {
        let switchMode =  this.sysConfigGetValueByKey('this.sysConfigGetValueByKey', '[{"checked":true,"checkedSrc":"selectCard","noCheckedSrc":"card","type":"card"},{"checked":false,"checkedSrc":"selectList","noCheckedSrc":"list","type":"list"},{"checked":false,"checkedSrc":"selectTimeAxis","noCheckedSrc":"timeAxis","type":"timeAxis"}]')
        switchMode=JSON.parse(switchMode);
        switchMode&&switchMode.length&&switchMode.forEach((item,index)=>{
            modeIcon&&modeIcon.length&&modeIcon.forEach((i,ids)=>{
                if(item.checkedSrc=== i.key ){
                    item.checkedSrc =i.src
                }
                if(item.noCheckedSrc=== i.key ){
                    item.noCheckedSrc =i.src
                }
            })
        });
        this.state.pictureCollection = switchMode;
        this.state.currentChecked=switchMode[0];
        this.setState({})


    }
    render() {
        let  sortList = this.sysConfigGetValueByKey("defaultSortList", '[{"title":"名称(升序)","status":"1","sortType":1,"sortCondition":"name"},{"title":"名称(降序)","status":"2","sortType":-1,"sortCondition":"name"},{"title":"日期(升序)","status":"3","sortType":1,"sortCondition":"createTime"},{"title":"日期(降序)","status":"4","sortType":-1,"sortCondition":"createTime"},{"title":"类型(升序)","status":"5","sortType":1,"sortCondition":"type"},{"title":"类型(降序)","status":"6","sortType":-1,"sortCondition":"type"},{"title":"大小(升序)","status":"7","sortType":1,"sortCondition":"size"},{"title":"大小(降序)","status":"8","sortType":-1,"sortCondition":"size"}]')
        sortList= JSON.parse(sortList);
        let {modeIcon} = this.state;
        const content = (
            <div>
                {this.state.currentChecked.type==='list'?null: <Radio.Group onChange={this.onChangeType} value={this.state.type} >
                    <p><Radio value={'small'}>小图标</Radio></p>
                    <p><Radio value={'middle'}>中图标</Radio></p>
                    <p><Radio value={'big'}>大图标</Radio></p>
                </Radio.Group>}
                {this.state.currentChecked.type==='card'? <Divider style={{margin:0}} />:null}
                {this.state.currentChecked.type==='timeAxis'?null: <div style={{paddingTop: '10px',}}>
                    <Radio.Group onChange={(e) => this.onChangeStatus(e,sortList)}  value={this.state.status}>
                        {sortList&&sortList.length&&sortList.map((item,index)=>{
                            return(
                                <p key={index}><Radio value={item.status}>{item.title}</Radio></p>
                            )
                        })}
                    </Radio.Group>
                </div>}

            </div>
        );
        let newSecondSelectColor =this.sysConfigGetValueByKey("NewMenuBg", "#0050B3");
         let width = document.body.clientWidth ;
        return(
            <div style={{display: 'flex',  justifyContent: width>1366?'end':'start', alignItems: 'center',}}>
                {/*选中包含子目录的时候出现停止按钮*/}
                {this.props.isShowStop? <div style={{color:'red',marginRight:10,cursor:'pointer'}} onClick={()=>{
                    this.props.clearTimer&&this.props.clearTimer()
                }}>停止</div>:null}
                {/*出现停止按钮*/}
                { !this.props.isAll?  <div>已加载{this.props.count}个</div>: <div>已全部加载， 共{this.props.count}个</div>}
                <div style={{display:'flex'}}>
                    {modeIcon.map((item,index)=>(
                        <div key={index}
                             style={{width:'30px',
                                 height:'30px',
                                 display: "flex",
                                 justifyContent: "center",
                                 alignItems: "center"}}  onClick={() => {
                                let checked = item.checked;
                                this.state.modeIcon.forEach(item2=>{item2.checked=false});
                                if(!checked) {
                                    item.checked =true;
                                 }else{
                                     this.state.modeIcon[0].checked = true
                                 }
                                 this.setState({},()=>{

                                         this.state.type='small';
                                         if(item.checked){
                                             // 如果当前选择的时光轴模式  就换成日期 倒序
                                             if(item.type ==="timeAxis"){
                                                 this.state.status = '4';
                                                 this.state.currentSort.sortCondition ='createTime';
                                                 this.state.currentSort.sortType ="-1";
                                             }else{
                                                 this.state.status = '5';
                                                 this.state.currentSort.sortCondition ='type';
                                                 this.state.currentSort.sortType ="1";

                                             }
                                             this.state.currentChecked =item;
                                             this.setState({});

                                             //传的参数：当前是那个图标（大图标小图标中途图标），选中的那个对象,排序的方式,是否刷新数据
                                             this.props.callBack&&this.props.callBack("small",item,this.state.currentSort,true)
                                         }

                                 })
                        }}
                        >
                            <MyIconSvg type={item.type}   style={{size:"20px"}} colors={item.checked?[newSecondSelectColor]:['#8C8C8C']}/>

                     </div>)

                    )}
                    {this.props.IsShow ?null:<div style={{marginLeft:"12px",width: "1px",background:'rgba(0, 0, 0, 0.15)', height: "9px",marginTop:'11px'}} ></div>}
                    {this.props.IsShow?null: <Popover style={{background:'red'}}  placement="leftTop" content={content}  visible={this.state.selectType}  trigger="hover" onVisibleChange={(visible) => {
                       this.setState({selectType:!this.state.selectType})
                     }}>
                        <div style={{width:'30px',height:'30px',display: "flex",
                        justifyContent: "center",
                        alignItems: "center"}}>
                        <MyIconSvg type={'calendar'}  style={{marginLeft: '12px',size:"20px"}}  colors={this.state.selectType?[newSecondSelectColor]:['#8C8C8C']}/></div>
                        </Popover>
                        }

                </div>
            </div>

        )
    }
    //切换排序
    onChangeStatus(e,SortList) {
        let current ={};
        SortList&&SortList.length&&SortList.forEach((item,index)=>{
            if(item.status === e.target.value ){
                current =item
            }
        });

        this.setState({status: e.target.value,currentSort:current,selectType:false},()=>{

            this.props.callBack&&this.props.callBack(this.state.type,this.state.currentChecked,this.state.currentSort,true)
        });
    }

    //切换大图标小图标中图标以及list
    onChangeType = e => {
        this.setState({type: e.target.value,selectType:false},()=>{
            this.props.callBack&&this.props.callBack(this.state.type,this.state.currentChecked,this.state.currentSort,false)
        });
    };
    init(){

        this.state.type= 'small';
        this.state.status= '5';
        this.setState({})
    }
    initStatus(){
        this.state.pictureCollection.forEach((item,index)=>{
            if(index === 0){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.state.currentSort.sortCondition='type';
        this.state.currentSort.sortType='1';
        this.state.type= 'small';
        this.state.status= '5';
        this.setState({},()=>{
            this.props.callBack&&this.props.callBack(this.state.type,this.state.currentChecked,this.state.currentSort,false)
        })
    }



}
